<template>
    <div class="w-full flex flex-col bg-warmGray-100 shadow px-1 md:px-2 py-2 text-sm">        <!--==========================================-->
          <!-- Here comes the first line of each basket Items  -->
          <div class="flex space-x-0">
                <div class="w-1/12 text-warmGray-700 font-semibold"> {{basketItem.quantity}} x </div>
                <div class="w-5/12 flex flex-col text-tighter ">
                    <p class="" v-html="basketItem.name"> </p>
                </div>
                <div class="w-2/12 flex text-center">
                    <p class="m-auto"> {{ numeralFormat(basketItem.currentPrice, '0,0[.]00 $')  }}</p>
                </div>
                    <!-- Here is the plus and minus  -->
                    <div class="w-4/12 flex justify-end   space-x-1  content-center items-center">
                        <button @click= "reduceCartItemQuantity(bIdx)"   class="bg-warmGray-50 my-auto text-center text-base md:text-3xl h-8 w-8 border border-warmGray-300" ><span class="m-auto text-center pb-4">-</span> </button>
                        <button @click= "increaseCartItemQuantity(bIdx)" class="bg-warmGray-50 my-auto text-center text-base md:text-3xl h-8 w-8 border border-warmGray-300" ><span class="m-auto text-center">+</span></button>
                        <button @click= "showZusatzTextInputField()"     class="bg-warmGray-50 my-auto text-center text-base md:text-3xl h-8 w-8 border border-warmGray-300" ><img src="@/assets/bilder/pencil.svg" class="h-8 w-7 px-1 m-auto"> </button>
                        <button @click="removeCartProduct(bIdx)"         class="bg-warmGray-50 my-auto text-center text-base md:text-3xl h-8 w-8 border border-warmGray-300" ><span class="m-auto text-center">x</span></button>
                    </div>
                    <!-- ============================ -->

           </div>
           <!-- End of first line of each basket items  -->
           <!-- ======================================================================= -->
             <!-- start : second of line of basket item  -->
           <dl className="flex flex-col  whitespace-pre">
                <div class=" flex flex-wrap p-2">
                 <dd v-if="basketItem.currentAuswahl"
                 class="text-warmGray-700 font-semibold"
                 v-html="basketItem.currentAuswahl.name">
                  </dd>
                   <dd v-if="basketItem.curScharfeStufe">
                    Scharfstufe: <span class="text-warmGray-700 font-semibold">
                    {{basketItem.curScharfeStufe}}, </span>
                   </dd>
                     <!-- next  -->
                  <dd v-if="basketItem.productPortion">
                   Portion: <span class="text-warmGray-700 font-semibold"
                   v-html="basketItem.productPortion">
                     </span>,
                   </dd>
                   <!-- next 00 -->
                  <dd v-if="basketItem.productType">
                   Typ: <span class="text-warmGray-700 font-semibold">
                    {{basketItem.productType}} </span>
                   </dd>
                    <!-- next  -->

                  </div>
                 <p class="px-2" v-html="basketItem.zusatzText"></p>
                 <!-- Here starts the edit part  -->
                <div v-if="showZusatzTextInput" class="py-2 shadow-sm border-t  border-warmGray-400 bg-lime-50">
                  <!-- here startsthe schrafstufe edit part  -->
                <!-- next starts here -->
                      <div v-if="getScharfeStufen.length"
                     class="p-2 shadow-sm flex justify-between items-center">
                  <dt> <label class="mr-2 font-semibold text-warmGray-800 "> Scharfstufe </label>
                  </dt>
                  <dd>
                   <select   v-model="curScharfeStufe"
                   class="w-44 mt-1 inline-block mt-1 w-30 border border-garmGray-300 px-2 py-1">
                   <option class="w-44 border border-warmGray-300"
                    :curScharfeStufe = basketItem.curScharfeStufe
                    v-for="(option) in getScharfeStufen"
                     :key="option"
                      :value="option.type">
                       {{ option.type}}
                   </option>

                   </select>
                  </dd>
               </div>
                    <!-- Here starts the auswahl type -->
                <div v-if="productTypeVec.length>1"
                  class="px-2 py-3  shadow-sm flex justify-between items-center ">
                  <dt> <label class=" font-semibold text-warmGray-800">  Typ </label>
                   </dt>
                   <dd>
                     <select v-model="productType"
                   class="w-44 mt-1 inline-block mt-1 w-30 border border-garmGray-300 px-2 py-1">
                   <option class=" border border-warmGray-300"
                    :productType = basketItem.productType
                    v-for="option in productTypeVec"
                     :key="option"
                      :value="option">
                       {{ option}}
                   </option>

                   </select>
                   </dd>
               </div>
            <!-- Here ends the auswahl typ  -->
                <!-- Here starts the Portion  -->
                <!-- <div v-if="productPortionVec.length>1"
                  class="px-2 py-3  shadow-sm flex justify-between items-center ">
                  <dt> <label class=" font-semibold text-warmGray-800"> Portion </label>
                   </dt>
                   <dd>
                     <select   v-model="productPortion"
                    class="w-44 form-select mt-1 inline-block mt-1 w-30 border border-garmGray-300 px-2 py-1">
                   <option class=" border border-warmGray-300"
                      :productPortion = basketItem.productPortion
                      v-for="option in productPortionVec"
                     :key="option"
                      :value="option">
                       {{ option}}
                   </option>

                   </select>
                   </dd>

               </div> -->
                    <!-- next ends here   -->
                    <fieldset class="py-1">
                        <legend class="text-tighter text-gray-800 font-medium pt-1">Anmerkung zu diesem Artikel</legend>
                        <!-- Here starts the additional text area  -->
                        <textarea  id="theFieldID"
                        onLoad="document.getElementById('theFieldID').focus();"
                        v-model="zusatzText"
                        placeholder="Wollen Sie Anmerkung zu diesem Artikel schreiben?
                        Z.B. &quot;Für mama/papa etc &quot; oder &quot;Ohne
                                Tomaten&quot; oder nicht pikant" cols="0" rows="4" maxlength="200"
                        class="w-full text-left border border-warmGray-500 bg-lime-50 px-2"
                        autofocus="autofocus"
                        >
                        </textarea>
                    </fieldset>
                    <div class="flex flex-row justify-center space-x-4 bg-lime-50 py-2 px-2">
                        <button class="block btn text-gray-600 font-semibold text-tighter px-1 py-2 rounded bg-warmGray-300"
                         @click ="showZusatzTextInputField()"
                        >
                           Abbrechen
                        </button>
                        <button v-if="showDeleteInZusatzText(basketItem.zusatzText)"
                            @click="remove_zusatztext_and_close"
                             class="btn text-gray-600 font-semibold text-tighter px-1 py-2 rounded bg-warmGray-300"
                          >
                        Löschen
                        </button>
                        <button
                         @click="add_zusatztext_and_close"
                         class="block btn text-gray-600 font-semibold text-tighter px-1 py-2 rounded bg-warmGray-300"
                        >
                          hinzufügen / Ändern
                        </button>
                    </div>
              </div>
              <!--==================================================================== -->

            </dl>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    basketItem: Object,
    bIdx: Number
  },
  data () {
    return {
      showZusatzTextInput: false,
      zusatzText: this.basketItem.zusatzText,
      curScharfeStufe: this.basketItem.curScharfeStufe,
      productType: this.basketItem.productType,
      productPortion: this.basketItem.productPortion
    }
  },
  computed: {
    // get product Portion vector: klein, groß
    productPortionVec () {
      var product = this.productByPosnr(this.basketItem.posnr)
      var portionVec = product.portion
      return portionVec
    },
    // get product tpye vegan vegetarisch
    productTypeVec () {
      var product = this.productByPosnr(this.basketItem.posnr)
      // console.log(product)
      var typeVec = []
      if (!product.auswahl.length) {
        typeVec = product.type
      }
      if (product.auswahl.length) {
        var currentAuswahl = this.basketItem.currentAuswahl
        var auswahl = product.auswahl.find(auswahl => auswahl.name === currentAuswahl.name)
        // var auswahl = product.auswahl[currentAuswahl]
        typeVec = auswahl.type
        // this.productType = typeVec[0]
      }
      return typeVec
    },
    // get schrafe stufe
    getScharfeStufen () {
      var product = this.productByPosnr(this.basketItem.posnr)
      return product.scharfeStufe
    },
    getCurScharfeStufe () {
      // console.log(this.basketItem.curScharfeStufe)
      return this.basketItem.curScharfeStufe
    },
    ...mapGetters({
      products: 'getAlleProdukte'
      // cartTotal: 'getFormCartTotal',
      // basketItems: 'getCartProducts',
      // totalCartItems: 'getTotalCartItems',
      // lieferkosten: 'getLieferKosten',
      // getPopupCart: 'getPopupCart'
    })
    // message: {
    //   get () {
    //     return this.$store.state.zusatzText
    //   },
    //   set (value) {
    //     this.$store.commit('updateMessage', value)
    //   }
    // }
  },
  methods: {
    ...mapActions({
      removeCartProduct: 'removeProductFromCart',
      reduceCartItemQuantity: 'reduceCartItemQuantity',
      increaseCartItemQuantity: 'increaseCartItemQuantity',
      addZusatzTextInCartItem: 'addZusatzTextInCartItem',
      removeZusatzTextInCartItem: 'removeZusatzTextInCartItem',
      productByPosnr: 'getProductByPosnr'
    }),
    remove_zusatztext_and_close () {
      this.zusatzText = ''
      this.removeZusatzTextInCartItem(this.bIdx)
      this.showZusatzTextInputField()
    },
    add_zusatztext_and_close () {
      var indexMessage = {
        zusatzText: this.zusatzText,
        curScharfeStufe: this.curScharfeStufe,
        productType: this.productType,
        productPortion: this.productPortion,
        index: this.bIdx
      }
      // this.$store.commit('updateMessage', indexMessage)
      this.addZusatzTextInCartItem(indexMessage)
      this.showZusatzTextInputField()
    },
    showModals () {
      if (this.showBasket) {
        // document.getElementsByTagName('html')[0].classList.remove('overflow-y-hidden')
        this.showBasket = false
      } else {
        this.showBasket = true
        // document.getElementsByTagName('html')[0].classList.add('overflow-y-hidden')
      }
    },
    hasProduct () {
      return this.getProductsInCart.length > 0
    },
    showZusatzTextInputField () {
      this.showZusatzTextInput = !this.showZusatzTextInput
      // this.zusatzText = ''s

      // this.productByPosnr(this.basketItem.posnr)
    },
    showDeleteInZusatzText (zusatzText) {
      if (zusatzText !== '') {
        return true
      }
      return false
    },
    productByPosnr (posnr) {
      return this.products.find(product => product.posnr === posnr)
    }
  }
}
</script>
<style scoped>
   .stickyButton{
      position: -webkit-sticky;
      align-self: flex-start;
      position: sticky;
      bottom: 0px !important;
   }
</style>
